module.exports = __webpack_public_path__ + "img/symbol_10_x1000.66522d21.png";